module.exports = __webpack_public_path__ + "img/PerformDash-Accelerate-Header.0ca3f35a.svg";